<section class="icip-coverage" id="coverage" aria-label="Coverage">
  <div class="icip-coverage__container">
    <div class="icip-coverage__label icip-reveal" appInView>Coverage</div>

    <div class="icip-coverage__card">
      <div class="icip-coverage__ambient" aria-hidden="true"></div>

      <div class="icip-coverage__content">
        <div class="icip-coverage__left icip-reveal icip-reveal--left" appInView>
          <div class="icip-coverage__live">
            <span class="icip-coverage__live-dot" aria-hidden="true"></span>
            All systems operational
          </div>

          <h2 class="icip-coverage__title">
            International
            <br />
            <span class="icip-coverage__title-accent">Caller ID Coverage</span>
          </h2>

          <p class="icip-coverage__subtitle">
            First Orion's ICIP platform delivers branded calling across 14+ active European markets — connecting enterprise brands to consumers at carrier level with verified caller identity.
          </p>

          <div class="icip-coverage__stats" aria-label="Coverage stats">
            <ng-container *ngFor="let s of stats; let i = index">
              <div class="icip-coverage__stat">
                <div class="icip-coverage__stat-value">{{ s.value }}</div>
                <div class="icip-coverage__stat-label">{{ s.label }}</div>
              </div>
              <div class="icip-coverage__stat-divider" *ngIf="i < stats.length - 1" aria-hidden="true"></div>
            </ng-container>
          </div>
        </div>

        <div class="icip-coverage__right icip-reveal icip-reveal--right" appInView>
          <canvas
            #globeCanvas
            class="icip-coverage__canvas"
            (pointerdown)="onPointerDown($event)"
            (pointermove)="onPointerMove($event)"
            (pointerup)="onPointerUp()"
            (pointercancel)="onPointerUp()"
          ></canvas>
        </div>
      </div>
    </div>
  </div>
</section>
